(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		if (!imagesWrapper) return;
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};



	const resolveFooterBoundary = () =>
		document.querySelector('footer') ||
		document.getElementById('shopify-section-footer') ||
		document.querySelector('[id^="shopify-section-"] .footer-container')?.closest(
			'[id^="shopify-section-"]'
		) ||
		document.querySelector('.footer-container');

	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup');
		if (!stickyBar) return;

		let triggerY;
		let footerTop;

		const computeTriggerScrollY = () => {
			const bb = document.querySelector(
				'.product-section .product__buy_buttons'
			);
			const prod = document.querySelector('.product-section');
			if (bb) {
				const r = bb.getBoundingClientRect();
				return r.bottom + window.scrollY;
			}
			if (prod) {
				const r = prod.getBoundingClientRect();
				return (
					r.top +
					window.scrollY +
					Math.min(r.height * 0.35, 420)
				);
			}
			return 380;
		};

		const refreshMetrics = () => {
			triggerY = computeTriggerScrollY();
			const boundary = resolveFooterBoundary();
			if (boundary) {
				footerTop =
					boundary.getBoundingClientRect().top + window.scrollY;
			} else {
				footerTop =
					document.documentElement.scrollHeight ||
					document.body.scrollHeight ||
					0;
			}
		};

		const mobileStickyMq =
			typeof window.matchMedia === 'function'
				? window.matchMedia('(max-width: 1099px)')
				: null;

		const handleScroll = () => {
			if (
				document.body.classList.contains('premium-mobile-buy-dock-on')
			) {
				stickyBar.classList.remove('active');
				return;
			}

			/* Variant PDPs (mf gallery) skip the premium dock — keep bottom bar visible on load, not scroll-gated */
			if (
				document.body.classList.contains('template-product') &&
				mobileStickyMq &&
				mobileStickyMq.matches
			) {
				stickyBar.classList.add('active');
				return;
			}

			const y = window.scrollY;
			const vh = window.innerHeight;

			const pastPrimaryCta = y > triggerY - vh * 0.5;
			const beforeFooter =
				y + vh < footerTop + Math.min(vh * 0.25, 200);

			stickyBar.classList.toggle(
				'active',
				pastPrimaryCta && beforeFooter
			);
		};

		const rerunStickyGate = () => {
			refreshMetrics();
			handleScroll();
		};

		rerunStickyGate();

		if (stickyBar.dataset.stickyHandlers === 'bound') return;
		stickyBar.dataset.stickyHandlers = 'bound';

		window.addEventListener('scroll', handleScroll, { passive: true });
		window.addEventListener(
			'resize',
			() => {
				rerunStickyGate();
			},
			{ passive: true }
		);

		window.addEventListener(
			'product-sticky-bar:refresh',
			rerunStickyGate,
			false
		);
	};

	document.addEventListener('shopify:section:load', function () {
		const stickyBar = document.querySelector('.product__popup');
		if (stickyBar) stickyBar.dataset.stickyHandlers = '';
		initProductAccordion();
		initZoomImage();
		revealPopup();
	});

	initProductAccordion();
	initZoomImage();
	revealPopup();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.originalSectionId = null;
		this.renderForm();
	}

	bindMainVariantSync() {
		if (this.dataset.mainVariantSync === '1') return;
		const sid = this.originalSectionId;
		if (!sid) return;

		const mainPicker = document.querySelector(
			`variant-radios[data-section=${JSON.stringify(
				sid
			)}], variant-selects[data-section=${JSON.stringify(sid)}]`
		);
		if (!mainPicker) return;

		this.dataset.mainVariantSync = '1';
		mainPicker.addEventListener('change', () => {
			this.syncFloatedVariantFromMain();
		});
	}

	/** Sticky bar HTML loads async; merge customer's selection from the main PDP picker. */
	syncFloatedVariantFromMain() {
		const sid = this.originalSectionId;
		if (!sid) return;

		const mainInput = document.querySelector(
			`#product-form-${CSS.escape(sid)} input[name="id"]`
		);
		const floatedInput = this.querySelector(
			`#product-form-floated-${CSS.escape(sid)} input[name="id"]`
		);
		const vid = mainInput && mainInput.value;
		if (!vid || !floatedInput) return;

		floatedInput.value = vid;
		floatedInput.disabled = false;

		const mainPicker = document.querySelector(
			`variant-radios[data-section=${JSON.stringify(
				sid
			)}], variant-selects[data-section=${JSON.stringify(sid)}]`
		);
		const floatedPicker = this.querySelector(
			"variant-radios, variant-selects"
		);
		if (!mainPicker || !floatedPicker) return;

		mainPicker.querySelectorAll("fieldset").forEach((mainFs, idx) => {
			const floatedFs = floatedPicker.querySelectorAll("fieldset")[idx];
			if (!floatedFs) return;
			const mc = mainFs.querySelector("input:checked");
			if (!mc) return;
			floatedFs.querySelectorAll('input[type="radio"]').forEach((inp) => {
				if (
					inp.value === mc.value &&
					!inp.disabled &&
					!inp.classList.contains("disabled")
				) {
					inp.checked = true;
				}
			});
		});

		mainPicker.querySelectorAll("select").forEach((mainSel, idx) => {
			const floatedSel = floatedPicker.querySelectorAll("select")[idx];
			if (floatedSel) floatedSel.value = mainSel.value;
		});

		floatedPicker.dispatchEvent(new Event("change", { bubbles: true }));
	}

	renderForm() {
		let fetchUrl = this.getAttribute("data-product-url") || "";
		try {
			const sid = this.id && this.id.replace(/^FloatedForm-/, "");
			const fromUrl = new URLSearchParams(window.location.search).get("variant");
			const mainInput =
				sid &&
				document.querySelector(
					`#product-form-${CSS.escape(sid)} input[name="id"]`
				);
			const variantId =
				fromUrl ||
				(mainInput && mainInput.value) ||
				"";
			if (variantId) {
				const url = new URL(fetchUrl, window.location.origin);
				url.searchParams.set("variant", String(variantId));
				fetchUrl = url.pathname + url.search;
			}
		} catch (e) {
			/* keep base product url */
		}

		fetch(fetchUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				window.setTimeout(() => {
					this.syncFloatedVariantFromMain();
				}, 0);
				window.setTimeout(() => {
					this.syncFloatedVariantFromMain();
				}, 250);

				this.bindMainVariantSync();

				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();

				window.dispatchEvent(new CustomEvent('product-sticky-bar:refresh'));
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.originalSectionId = sectionId;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		this.productElement
			.querySelectorAll(".product-variant-image")
			.forEach((el) => {
				el.remove();
			});

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);
